import { useEffect } from 'react';

import { useGlobalData } from 'providers/GlobalDataProvider';
import { clearFraudSessionId, storeFraudSessionId } from 'utils/localStorageData';

export const useFraudSession = () => {
  const { paymentConfig } = useGlobalData();

  useEffect(() => {
    if (!!paymentConfig) {
      const { finixEnvironment, finixMerchantId } = paymentConfig;

      if (!!finixMerchantId && !!finixEnvironment) {
        window.Finix.Auth(finixEnvironment, finixMerchantId, (sessionKey: string) => {
          storeFraudSessionId(sessionKey);
        });
      }
    }
    return () => clearFraudSessionId();
  }, [paymentConfig]);
};
